import styled from '@emotion/styled';

export const MainContentLoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    position: relative;
    gap: 30px;
    background-color: #f5f5f5;
`;

export const MainContentLoaderMessage = styled.div`
    font-size: 30px;
    font-weight: 700;
`;
